import { logError } from '@ecomm/error-handling'
import { safeFetchJson } from '@jvlk/fp-ts-fetch'
import * as T from 'fp-ts/lib/Task'
import * as TE from 'fp-ts/lib/TaskEither'
import { pipe } from 'fp-ts/lib/function'

export const requestLiveChatAvailability = (
  appId: string,
  handleFailure: () => void,
  handleSuccess: (isAvailable: boolean) => void
) => {
  return pipe(
    safeFetchJson(
      `https://prod-live-chat.sprinklr.com/api/livechat/handshake/check-visibility/${appId}`
    ),
    TE.fold(
      e => {
        logError(
          Error(`Failed to load LiveChat availability: ${JSON.stringify(e)}`)
        )
        return T.of(handleFailure())
      },
      res => T.of(handleSuccess(res === true))
    )
  )()
}
